(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-draw-card/assets/javascripts/printable-draw-card.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-draw-card/assets/javascripts/printable-draw-card.js');
"use strict";


const formatCurrency = svs.utils.format.Currency;
const formatDate = svs.components.poolBetting.utils.formatDate;
const PrintableDrawCard = _ref => {
  let draw = _ref.draw,
    jackpot = _ref.jackpot;
  return React.createElement("div", {
    className: "pb_print_draw_card"
  }, React.createElement("div", {
    className: "draw__title"
  }, React.createElement("div", {
    className: "draw_card__label"
  }, "Omg\xE5ng"), draw.drawComment), React.createElement("div", {
    className: "draw__net_sale"
  }, React.createElement("div", {
    className: "draw_card__label"
  }, "Oms\xE4ttning"), "".concat(formatCurrency(draw.currentNetSale), " kr")), React.createElement("div", {
    className: "draw__close_time"
  }, React.createElement("div", {
    className: "draw_card__label"
  }, "Spelstopp"), formatDate(draw.regCloseTime, {
    showDayOfWeek: true
  })), jackpot && React.createElement("div", {
    className: "draw__jackpot"
  }, React.createElement("div", {
    className: "draw_card__label"
  }, "Jackpot"), jackpot));
};
setGlobal('svs.components.poolBetting.printableDrawCard.PrintableDrawCard', PrintableDrawCard);

 })(window);